import Quickview from './Quickview'

export default {
  Quickview
}
